module.exports = __webpack_public_path__ + "assets/uk-flag.f6616942.svg";